import type { ComputedRef, Ref } from "vue"
import { createContext } from "reka-ui"

export const SIDEBAR_COOKIE_NAME = "sidebar_state"
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7
export const SIDEBAR_WIDTH = "16rem"
export const SIDEBAR_WIDTH_MOBILE = "18rem"
export const SIDEBAR_WIDTH_ICON = "3rem"
export const SIDEBAR_KEYBOARD_SHORTCUT = "b"
/** Resizable desktop sidebar width bounds and default, in rem. */
export const SIDEBAR_WIDTH_DEFAULT_REM = 16
export const SIDEBAR_WIDTH_MIN_REM = 10
export const SIDEBAR_WIDTH_MAX_REM = 20

export const [useSidebar, provideSidebarContext] = createContext<{
  state: ComputedRef<"expanded" | "collapsed">
  open: Ref<boolean>
  setOpen: (value: boolean) => void
  isMobile: Ref<boolean>
  openMobile: Ref<boolean>
  setOpenMobile: (value: boolean) => void
  toggleSidebar: () => void
  /** Desktop width in rem, clamped to SIDEBAR_WIDTH_MIN_REM..SIDEBAR_WIDTH_MAX_REM. */
  width: Ref<number>
  /** Set the width; `commit` also emits `update:width` (e.g. once a drag ends). */
  setWidth: (rem: number, options?: { commit?: boolean }) => void
  /** True while the rail is being dragged (transitions are switched off meanwhile). */
  isResizing: Ref<boolean>
}>("Sidebar")
